/**
 * A service to implement functions generically used on the Shop's module:
 * 1 - a function to get all the available Delivery Options: the delivery option name, description and price;
 * 2 - a function to validate if the Shopping Cart is valid: if the Items are available for the online shop and
 *  if the Items' stock is available for the requested quantity;
 * 3 - a function to send to the backend the Shopping Cart to submit the Customer's Purchase.
 */

import {apiFetch} from '@/_helpers';
import {apiPost} from "../../_helpers";


export const genericService = {
    getDeliveryOptions,
    getPaymentOptions,
    validateCustomerPurchase,
    setCustomerPurchase
};


/**
 * A function to get all the available Delivery Options: the delivery option name, description and price.
 *
 * @returns {*}
 */
function getDeliveryOptions() {
    return apiFetch("deliveryoptions/");
}

/**
 * A function to get all the available Payment Methods: the method name, the identifier and the description.
 *
 * @returns {*}
 */
function getPaymentOptions() {
    return apiFetch("paymentoptions/");
}

/**
 * A function to validate if the Shopping Cart is valid: if the Items are available for the online shop and
 *  if the Items' stock is available for the requested quantity.
 * This function receives a response with two elements: (1) a dictionary with all the Items on the shopping cart and
 * their Stock value; (2) the status of the request: HTTP_400_BAD_REQUEST if the recaptcha was unsuccessfully validated
 * or a HTTP_200_OK.
 *
 * @param attributes
 * @returns {*|Promise|Promise<unknown>}
 */
function validateCustomerPurchase(attributes) {
    return apiPost("validatecustomerpurchase/", attributes);
}


/**
 * A function to send to the backend the Shopping Cart to submit the Customer's Purchase.
 * This function receives a response with two elements:
 * (1) a dictionary with:
 *  (1.1) a status 0/1,
 *  (1.2) an error code:
 *      (1.2.1) Err101: the number of submitted Customer Purchases is exceeded;
 *      (1.2.2) Err102: there was an error creating the  Customer Purchase register.
 *  (1.3) the created Customer Purchase code
 * (2) the status of the request: HTTP_400_BAD_REQUEST if the recaptcha was unsuccessfully validated or a HTTP_200_OK.
 *
 * @param attributes
 * @returns {*|Promise|Promise<unknown>}
 */
function setCustomerPurchase(attributes) {
    return apiPost("setcustomerpurchase/", attributes);
}

